import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function MutualFunds({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/StockFunds");
    };

    const goPrev = () => {
        navigate("/BuyAndSellBonds");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Mutual Funds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    A mutual fund pools assets from shareholders to invest in bonds, stocks, and 
                </div>
                <div className="text-[#000000] text-3xl">
                    similar in order to turn a profit for the shareholders.  Each shareholder 
                </div>
                <div className="text-[#000000] text-3xl">
                    participates proportionally to the gains or losses of the funds.
                </div>
                <div className="text-[#000000] text-3xl">
                    The 4 most common mutual funds are stock funds, money market funds, bond 
                </div>
                <div className="text-[#000000] text-3xl">
                    funds, and target-date funds.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}